var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-modal" }, [
    _c("div", { staticClass: "ui-modal--close-wrap" }, [
      _c("div", { staticClass: "ui-modal--close" }, [
        _c("button", {
          staticClass: "ui-modal--close-button",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.onCloseRequested($event)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    !!_vm.$slots.header
      ? _c("header", { staticClass: "ui-modal--header" }, [_vm._t("header")], 2)
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.default
      ? _c("main", { staticClass: "ui-modal--body" }, [_vm._t("default")], 2)
      : _vm._e(),
    _vm._v(" "),
    !!_vm.$slots.footer
      ? _c("footer", { staticClass: "ui-modal--footer" }, [_vm._t("footer")], 2)
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48a565f8", { render: render, staticRenderFns: staticRenderFns })
  }
}